import { render, staticRenderFns } from "./SkeletonLoader_2.vue?vue&type=template&id=5377630a&scoped=true"
import script from "./SkeletonLoader_2.vue?vue&type=script&lang=js"
export * from "./SkeletonLoader_2.vue?vue&type=script&lang=js"
import style0 from "./SkeletonLoader_2.vue?vue&type=style&index=0&id=5377630a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5377630a",
  null
  
)

export default component.exports